import { createApiCall } from 'lib/base';

const SYNC_WEALTH_CASH_BALANCE = 'WEALTH/SYNC_WEALTH_CASH_BALANCE';

const apiCall = createApiCall(
  SYNC_WEALTH_CASH_BALANCE,
  ({ id }: { id: string }) => ({
    endpoint: `/api/admin/wealth/programs/${id}/sync-cash-balance`,
    method: 'POST',
    notify: true,
  })
);

export default apiCall;
